import { useMediaQuery } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { format } from 'date-fns'
import { useContext } from 'react'
import ArrowLeft from 'assets/icons/nucleo/18px_arrow-left.svg'
import ArrowRight from 'assets/icons/nucleo/18px_arrow-right.svg'
import { LocaleContext } from 'components/common/LocaleContext'
import { themeUtils } from 'styles/theme'
import { Buttons } from './Buttons'
import { DateRangeCalendar, DateTabContainer } from './DateTabContent.style'
import { SearchBarContext } from './SearchBarContext'
import { SearchTab } from './SearchBarHeader'

interface DateTabContentProps {
  setSearchTab: (tab: SearchTab) => void
}

export const DateTabContent = ({ setSearchTab }: DateTabContentProps) => {
  const { fnsLocale, selectedMuiDateLocale } = useContext(LocaleContext)
  const { setDateRange, dateRange } = useContext(SearchBarContext)
  const isMobile = useMediaQuery(themeUtils.maxWidth.sm)

  return (
    <LocalizationProvider
      localeText={
        selectedMuiDateLocale.components.MuiLocalizationProvider.defaultProps
          .localeText
      }
      dateAdapter={AdapterDateFns}
      adapterLocale={fnsLocale}
    >
      <DateTabContainer>
        <DateRangeCalendar
          value={dateRange}
          onChange={setDateRange}
          slots={{
            leftArrowIcon: () => <ArrowLeft />,
            rightArrowIcon: () => <ArrowRight />
          }}
          calendars={isMobile ? 1 : 2}
          dayOfWeekFormatter={(day) =>
            format(day, 'EEE', { locale: fnsLocale }).replace('.', '')
          }
        />
        <Buttons
          apply={() => setSearchTab('location')}
          clear={() => setDateRange([null, null])}
        />
      </DateTabContainer>
    </LocalizationProvider>
  )
}
